export default __webpack_public_path__ + "static/Base5-acd301bbfb202ed01b2a8ba81e42ad90.png";